// Section 12: Flux (gut illness). 25% of illness rolls; 2 seasons untreated, 1 treated; death 8%
// per season untreated; contagious via water; water demand 1.5x (the S7 sick rule).
// Constants: config.illnesses.flux.
import type { Config } from '../../config';
import { noDeltas } from '../../core/content-helpers';
import { defineIllness, noModifiers } from '../../core/registry';

export function flux(config: Config) {
  const c = config.illnesses.flux;

  return defineIllness({
    id: 'flux',
    label: 'Flux',
    section: 'S12',
    source: 'roll',
    weight: c.weight,
    untreatedSeasons: c.untreated,
    treatedSeasons: c.treated,
    deathChance: c.death,
    contagious: true,
    modifierTargets: [],
    modifiers: noModifiers,
    onCatch: (ctx, person) => [
      { kind: 'memory', personId: person.id, entry: { turn: ctx.season.turn, kind: 'fell-ill' } },
    ],
    onRecover: noDeltas,
  });
}
